import Joi from "joi";
import { useState } from "react";

export function useFormulario(initialState = {}, formSchema = false) {
    const [formData, setFormData] = useState(initialState);
    const [formErrors, setFormErrors] = useState([]);
    const schema = formSchema


    const handleChangeFromEvent = (e) => {
        const { name, value } = e.target;
        const val = value;

        setFormData((prev) => ({
            ...prev,
            [name]: val,
        }));
    };

    const handleChangeFromValue = (name, val) => setFormData((prev) => ({
        ...prev,
        [name]: val,
    }));

    const resetForm = () => setFormData(initialState);

    const validateField = (fieldName, value) => {
        if (!formSchema)
            return
        try {
            const valueToValidate = value === undefined ? formData[fieldName] : value;
            const fieldToValidate = { [fieldName]: valueToValidate };
            const fieldSchema = Joi.object({ [fieldName]: schema.extract(fieldName) });
            const result = fieldSchema.validate(fieldToValidate);
            if (!result.error) {
                setFormErrors((prev) => prev.filter((error) => !error[fieldName]));
                return true;
            } else {
                const errorMessage = { [fieldName]: result.error.details[0].message };
                setFormErrors((prev) => [
                    ...prev.filter((error) => !error[fieldName]),
                    errorMessage,
                ]);
                return false;
            }
        } catch (error) {
            console.error(`Error validando campo ${fieldName}:`, error.message);
        }
    };

    const createErrorHint = (fieldName, message, variant = 'error') => setFormErrors((prev) => [
        ...prev.filter((error) => !error[fieldName]),
        {
            [fieldName]: message,
            variant
        },
    ]);

    const clearErrorHint = (fieldName) => {
        if (fieldName)
            setFormErrors((prev) => prev.filter((error) => !error[fieldName]))
        else setFormErrors([])
    };

    return { formData, formErrors, handleChangeFromEvent, handleChangeFromValue, resetForm, setFormData, validateField, setFormErrors, createErrorHint, clearErrorHint };
}